@if (!redirection) {
  <h1>Registrieren Sie sich einfach und schnell im PHOENIX Apothekenportal</h1>
}
